import "./index.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import { GoogleRedirectPage } from "./pages/GoogleRedirectPage";
import { UnauthorizedPage } from "./pages/UnauthorizedPage";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "./components/ThemeProvider";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import RegistrationPage from "./pages/RegistrationPage";
import ProtectedRoute from "./components/ProtectedRoute";
import UnProtectedRoute from "./components/UnProtectedRoute";
import { useAuthStore, initializeAuth } from "@/stores/authStore";
import { useAppStore } from "@/stores/appStore";
import { useEffect } from "react";
import { Loader } from "@/components/Loader";
import { generateProtectedRoutes } from "@/lib/routeGenerator";
import { getAllRouteConfigs } from "@/lib/routeConfig";

export function App() {
  const { initialized } = useAuthStore();
  const { effectiveTheme } = useAppStore();

  useEffect(() => {
    initializeAuth();
  }, []);

  // Show loading while auth is initializing
  if (!initialized) {
    return (
      <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
        <div className="flex min-h-screen items-center justify-center">
          <Loader />
        </div>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
      <BrowserRouter>
        <Toaster richColors theme={effectiveTheme} />
        <Routes>
          {/* Public routes */}
          <Route path="/google-login" element={<GoogleRedirectPage />} />

          <Route element={<UnProtectedLayoutRoute />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegistrationPage />} />
          </Route>

          {/* Protected routes */}
          <Route element={<ProtectedLayoutRoute />}>
            <Route path="/" element={<Navigate to="/admin" replace />} />

            {/* Auto-generated routes from configuration */}
            {generateProtectedRoutes(getAllRouteConfigs())}
          </Route>

          {/* Unauthorized access page */}
          <Route path="/unauthorized" element={<UnauthorizedPage />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;

function ProtectedLayoutRoute() {
  return (
    <ProtectedRoute>
      <Layout>
        <Outlet />
      </Layout>
    </ProtectedRoute>
  );
}

function UnProtectedLayoutRoute() {
  return (
    <UnProtectedRoute>
      <Outlet />
    </UnProtectedRoute>
  );
}
